"use client";

import { c as _c } from "react/compiler-runtime";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import { DropInteractionParams, DropLocation } from "../Drop";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { useState, useCallback } from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import WaveDropActions from "../WaveDropActions";
import WaveDropMobileMenu from "../WaveDropMobileMenu";
import WaveDropContent from "../WaveDropContent";
import WaveDropMetadata from "../WaveDropMetadata";
import WaveDropAuthorPfp from "../WaveDropAuthorPfp";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { cicToType, getTimeAgoShort } from "@/helpers/Helpers";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import WaveDropReactions from "../WaveDropReactions";
interface EndedParticipationDropProps {
  readonly drop: ExtendedDrop;
  readonly showWaveInfo: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly showReplyAndQuote: boolean;
  readonly location: DropLocation;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onDropContentClick?: (drop: ExtendedDrop) => void;
  readonly parentContainerRef?: React.RefObject<HTMLElement | null>;
}
export default function EndedParticipationDrop(t0) {
  const $ = _c(85);
  const {
    drop,
    showWaveInfo,
    activeDrop,
    showReplyAndQuote,
    location,
    onReply,
    onQuote,
    onQuoteClick,
    onDropContentClick,
    parentContainerRef
  } = t0;
  const isActiveDrop = activeDrop?.drop.id === drop.id;
  const router = useRouter();
  let t1;
  if ($[0] !== drop.author.cic) {
    t1 = cicToType(drop.author.cic);
    $[0] = drop.author.cic;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cicType = t1;
  const [activePartIndex, setActivePartIndex] = useState(0);
  const [longPressTriggered, setLongPressTriggered] = useState(false);
  const [isSlideUp, setIsSlideUp] = useState(false);
  const isMobile = useIsMobileDevice();
  let t2;
  if ($[2] !== router) {
    t2 = (e, path) => {
      e.preventDefault();
      e.stopPropagation();
      router.push(path);
    };
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleNavigation = t2;
  let t3;
  if ($[4] !== isMobile) {
    t3 = () => {
      if (!isMobile) {
        return;
      }
      setLongPressTriggered(true);
      setIsSlideUp(true);
    };
    $[4] = isMobile;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleLongPress = t3;
  let t4;
  if ($[6] !== activePartIndex || $[7] !== drop || $[8] !== onReply) {
    t4 = () => {
      setIsSlideUp(false);
      onReply({
        drop,
        partId: drop.parts[activePartIndex].part_id
      });
    };
    $[6] = activePartIndex;
    $[7] = drop;
    $[8] = onReply;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleOnReply = t4;
  let t5;
  if ($[10] !== activePartIndex || $[11] !== drop || $[12] !== onQuote) {
    t5 = () => {
      setIsSlideUp(false);
      onQuote({
        drop,
        partId: drop.parts[activePartIndex].part_id
      });
    };
    $[10] = activePartIndex;
    $[11] = drop;
    $[12] = onQuote;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const handleOnQuote = t5;
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setIsSlideUp(false);
    };
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handleOnAddReaction = t6;
  const t7 = `${location === DropLocation.WAVE ? "tw-px-4 tw-py-1" : ""} tw-w-full`;
  const t8 = `tw-relative tw-w-full tw-flex tw-flex-col tw-px-4 tw-py-3 tw-rounded-lg tw-overflow-hidden tw-group tw-transition-colors tw-duration-200 tw-ease-linear
          ${isActiveDrop ? "tw-bg-[#3CCB7F]/10" : location === DropLocation.WAVE ? "tw-bg-iron-900/60 tw-ring-1 tw-ring-inset tw-ring-iron-800" : "tw-bg-iron-950 tw-ring-1 tw-ring-inset tw-ring-iron-800"}`;
  let t9;
  if ($[15] !== activePartIndex || $[16] !== drop || $[17] !== handleOnQuote || $[18] !== handleOnReply || $[19] !== isMobile || $[20] !== showReplyAndQuote) {
    t9 = !isMobile && showReplyAndQuote && <WaveDropActions drop={drop} activePartIndex={activePartIndex} showVoting={false} onReply={handleOnReply} onQuote={handleOnQuote} />;
    $[15] = activePartIndex;
    $[16] = drop;
    $[17] = handleOnQuote;
    $[18] = handleOnReply;
    $[19] = isMobile;
    $[20] = showReplyAndQuote;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== drop) {
    t10 = <WaveDropAuthorPfp drop={drop} />;
    $[22] = drop;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== cicType || $[25] !== drop.author.level) {
    t11 = <UserCICAndLevel level={drop.author.level} cicType={cicType} size={UserCICAndLevelSize.SMALL} />;
    $[24] = cicType;
    $[25] = drop.author.level;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== drop.author.handle || $[28] !== handleNavigation) {
    t12 = e_0 => handleNavigation(e_0, `/${drop.author.handle}`);
    $[27] = drop.author.handle;
    $[28] = handleNavigation;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  const t13 = `/${drop.author.handle}`;
  let t14;
  if ($[30] !== drop.author.handle || $[31] !== t12 || $[32] !== t13) {
    t14 = <p className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold"><Link onClick={t12} href={t13} className="tw-no-underline tw-text-iron-200 hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out">{drop.author.handle}</Link></p>;
    $[30] = drop.author.handle;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== drop.created_at) {
    t16 = getTimeAgoShort(drop.created_at);
    $[35] = drop.created_at;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t16) {
    t17 = <p className="tw-text-xs tw-mb-0 tw-whitespace-nowrap tw-font-normal tw-leading-none tw-text-iron-500">{t16}</p>;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t11 || $[40] !== t14 || $[41] !== t17) {
    t18 = <div className="tw-flex tw-items-center tw-gap-x-2">{t11}{t14}{t15}{t17}</div>;
    $[39] = t11;
    $[40] = t14;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="tw-flex tw-items-center tw-rounded-md tw-font-medium tw-whitespace-nowrap tw-px-2 tw-py-0.5 tw-bg-iron-600/10 tw-text-iron-500 tw-border tw-border-solid tw-border-iron-500/25 tw-w-fit"><span className="tw-text-xs">Participant</span></div>;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t18) {
    t20 = <div className="tw-flex tw-flex-col tw-gap-y-2">{t18}{t19}</div>;
    $[44] = t18;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== drop.wave || $[47] !== handleNavigation || $[48] !== showWaveInfo) {
    t21 = showWaveInfo && (() => {
      const waveMeta = (drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean;
            };
          };
        };
      })?.chat;
      const isDirectMessage = waveMeta?.scope?.group?.is_direct_message ?? false;
      const waveHref = getWaveRoute({
        waveId: drop.wave.id,
        isDirectMessage,
        isApp: false
      });
      return <Link href={waveHref} onClick={e_1 => handleNavigation(e_1, waveHref)} className="tw-text-[11px] tw-leading-0 tw-text-iron-500 hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out tw-no-underline">{drop.wave.name}</Link>;
    })();
    $[46] = drop.wave;
    $[47] = handleNavigation;
    $[48] = showWaveInfo;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== activePartIndex || $[51] !== drop || $[52] !== handleLongPress || $[53] !== onDropContentClick || $[54] !== onQuoteClick || $[55] !== parentContainerRef) {
    t22 = <WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onLongPress={handleLongPress} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} setLongPressTriggered={setLongPressTriggered} parentContainerRef={parentContainerRef} isCompetitionDrop={true} />;
    $[50] = activePartIndex;
    $[51] = drop;
    $[52] = handleLongPress;
    $[53] = onDropContentClick;
    $[54] = onQuoteClick;
    $[55] = parentContainerRef;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== t20 || $[58] !== t21 || $[59] !== t22) {
    t23 = <div className="tw-flex tw-flex-col tw-w-full tw-gap-y-2">{t20}{t21}{t22}</div>;
    $[57] = t20;
    $[58] = t21;
    $[59] = t22;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  let t24;
  if ($[61] !== t10 || $[62] !== t23) {
    t24 = <div className="tw-flex tw-gap-x-3 tw-w-full tw-text-left tw-bg-transparent tw-border-0">{t10}{t23}</div>;
    $[61] = t10;
    $[62] = t23;
    $[63] = t24;
  } else {
    t24 = $[63];
  }
  let t25;
  if ($[64] !== drop.metadata) {
    t25 = drop.metadata.length > 0 && <div className="tw-flex tw-w-full tw-items-center tw-gap-x-2 tw-gap-y-1 tw-flex-wrap"><WaveDropMetadata metadata={drop.metadata} /></div>;
    $[64] = drop.metadata;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== drop) {
    t26 = <div className="tw-flex tw-w-full tw-items-center tw-gap-x-2 tw-gap-y-1 tw-flex-wrap"><WaveDropReactions drop={drop} /></div>;
    $[66] = drop;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  let t27;
  if ($[68] !== drop || $[69] !== handleOnQuote || $[70] !== handleOnReply || $[71] !== isSlideUp || $[72] !== longPressTriggered || $[73] !== showReplyAndQuote) {
    t27 = <WaveDropMobileMenu drop={drop} isOpen={isSlideUp} longPressTriggered={longPressTriggered} showReplyAndQuote={showReplyAndQuote} setOpen={setIsSlideUp} onReply={handleOnReply} onQuote={handleOnQuote} onAddReaction={handleOnAddReaction} />;
    $[68] = drop;
    $[69] = handleOnQuote;
    $[70] = handleOnReply;
    $[71] = isSlideUp;
    $[72] = longPressTriggered;
    $[73] = showReplyAndQuote;
    $[74] = t27;
  } else {
    t27 = $[74];
  }
  let t28;
  if ($[75] !== t24 || $[76] !== t25 || $[77] !== t26 || $[78] !== t27 || $[79] !== t8 || $[80] !== t9) {
    t28 = <div className={t8}>{t9}{t24}{t25}{t26}{t27}</div>;
    $[75] = t24;
    $[76] = t25;
    $[77] = t26;
    $[78] = t27;
    $[79] = t8;
    $[80] = t9;
    $[81] = t28;
  } else {
    t28 = $[81];
  }
  let t29;
  if ($[82] !== t28 || $[83] !== t7) {
    t29 = <div className={t7}>{t28}</div>;
    $[82] = t28;
    $[83] = t7;
    $[84] = t29;
  } else {
    t29 = $[84];
  }
  return t29;
}